import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

function LanguageSelection() {
  return (
    <div className="language-selection">
      <h1>Choose Your Language</h1>
      <div className="language-buttons">
        <Link to="/arabic">
          <button className="language-button">Arabic</button>
        </Link>
        <Link to="/chinese">
          <button className="language-button">Chinese</button>
        </Link>
        <Link to="/japanese">
          <button className="language-button">Japanese</button>
        </Link>
      </div>
    </div>
  );
}

export default LanguageSelection;
